import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { App, Button, Card, Space } from 'antd';
import { ProfileOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import PageHeader from 'components/headings/PageHeader';
import ComponentAttributeDefsContent from 'pages/liftlogic/v2/Components/ComponentAttributeDefsContent';

function TenantComponentAttributeDefsPage() {
  const { tenantId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const tenantName = location.state?.tenantName || `Tenant ${tenantId}`;

  return (
    <App>
      <div style={{ padding: 16 }}>
        <PageHeader
          icon={ProfileOutlined}
          title="Catálogo de atributos de componentes"
          subtitle={`Tenant: ${tenantName}`}
          actions={
            <Space>
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={() =>
                  navigate(`/admin/tenants/${tenantId}/edit`, { state: location.state })
                }
              >
                Volver al tenant
              </Button>
            </Space>
          }
        />
        <Card>
          <ComponentAttributeDefsContent />
        </Card>
      </div>
    </App>
  );
}

export default TenantComponentAttributeDefsPage;
